import { render } from "./UPSPage.vue?vue&type=template&id=1c932ac3"
import script from "./UPSPage.vue?vue&type=script&lang=js"
export * from "./UPSPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__